import React, { useState, useEffect } from 'react';
import JHApi from "../../../utils/JHApi"
import { Box, Button, Chip, Collapse, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import InterviewsDialog from './InterviewsDialog';
import ContractOfferDialog from './ContractOfferDialog';
import { CLOSED_INTERVIEW_STATUSSES, capitalize, getColorFromString, getNameFromEmail, showDateTimeFromString } from '../../../utils/utils';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import EditIcon from '@mui/icons-material/Edit';
import { JourneyClasses } from '../../../styles/JourneyClasses';

//import Lightbulb from 'mdi-material-ui/Lightbulb'

function InterviewProcessRow(props) {
    const interviewProcess = props.interviewProcess
    const disabled = props.disabled

    const color = getColorFromString(interviewProcess.company, 'avatars')

    const [open, setOpen] = useState(false);

    const journeyClasses = JourneyClasses()

    return (
        <>
            <TableRow>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {showDateTimeFromString(interviewProcess.last, false)}
                </TableCell>
                <TableCell component="th" scope="row">
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <span className={journeyClasses.tableAvatar} style={{color: color.dark, backgroundColor: color.light}}>{interviewProcess.company.charAt(0).toUpperCase()}</span>
                        <span>{capitalize(interviewProcess.company)}</span>
                    </div>
                </TableCell>
                <TableCell component="th" scope="row">
                    {interviewProcess.interviews[0].title}
                </TableCell>
                <TableCell component="th" scope="row">
                    <Chip
                        size="small" 
                        label={interviewProcess.status}
                        onClick={()=>props.handleEditStatus(interviewProcess.interviews[0])} 
                        color="primary" 
                        onDelete={()=>props.handleEditStatus(interviewProcess.interviews[0])} 
                        deleteIcon={<EditIcon/>}
                        disabled={disabled}
                    />
                </TableCell>
                <TableCell component="th" scope="row">
                    {interviewProcess.interviews.length}
                </TableCell>
                {/*<TableCell component="th" scope="row">
                    <Button 
                        variant='contained' 
                        color='primary' 
                        disabled={disabled} 
                        size='small' 
                        style={{textTransform: 'capitalize'}}
                        onClick={()=>handleNewInterviewInProccess(interviewProcess.interviews[0])}
                    ><CalendarTodayIcon style={{fontSize: 12, marginRight: 8}}/>Recap Imterview</Button>
                </TableCell>*/}
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Date</TableCell>
                                        <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Step</TableCell>
                                        <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Asked Questions</TableCell>
                                        <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Summary</TableCell>
                                        <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {interviewProcess.interviews.map((interview) => (
                                    <TableRow key={interview._id}>
                                        <TableCell component="th" scope="row">
                                            {showDateTimeFromString(interview.interviewDate, false)}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {interview.type}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <div dir="auto" style={{whiteSpace:'pre-line'}}>
                                                {interview.askedQuestions}
                                            </div>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <div dir="auto" style={{whiteSpace:'pre-line'}}>
                                                {interview.reviewFreeText}
                                            </div>
                                            {(interview.clientSummary||[]).map(summary => (
                                                <div key={summary.date}>
                                                    <strong>
                                                        {summary.isAdmin?(getNameFromEmail(summary.by) + ' - '):''}
                                                        {showDateTimeFromString(summary.date, false)}
                                                    </strong><br/>
                                                    <span dir="auto" style={{whiteSpace: 'pre-line', display: 'block'}}>{summary.content}</span>
                                                </div>
                                            ))}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Button 
                                                variant='contained' 
                                                color='primary' 
                                                disabled={disabled} 
                                                size='small' 
                                                style={{textTransform: 'capitalize'}}
                                                onClick={()=>props.handleEditInterview(interview)}
                                            >
                                                {/*<CalendarTodayIcon style={{fontSize: 12, marginRight: 8}}/>*/}
                                                Edit Interview
                                            </Button>
                                            {/*<Button 
                                                variant='contained' 
                                                color='primary' 
                                                disabled={disabled} 
                                                size='small' 
                                                style={{textTransform: 'capitalize'}}
                                                onClick={()=>props.handleRecapInterview(interview)}
                                            >
                                                Recap Interview
                                            </Button>*/}                                            
                                        </TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}

export default function InterviewTracker(props) {
    const isLoading = props.isLoading || false
    const journeyData = props.journeyData || {} 
    const isAdmin = props.isAdmin
    const userId = props.userId
    const journeyId = journeyData._id

    const [interviews, setInterviews] = useState([]);
    const [talentOffers, setTalentOffers] = useState([]);
    //const [ratingsFields, setRatingsFields] = useState([]);
    const [isLoadingInterviews, setIsLoadingInterviews] = useState(false);
    const [objectToEdit, setObjectToEdit] = useState();
    const [offerToEdit, setOfferToEdit] = useState();

    const [interviewProcesses, setInterviewProcesses] = useState([]);

    //const [explanationDialog, setExplanationDialog] = useState({open:false});

    const disabled = isLoading || isLoadingInterviews
    const today = new Date().toISOString().substring(0, 10)

    useEffect(() => {
        if (journeyId){
            let paramsToPass = {}

            if (isAdmin){
                paramsToPass.userId = userId
            }

            setIsLoadingInterviews(true)

            JHApi.getInterviewsForUser(paramsToPass,(response)=>{
                /*const newCycles = (response.cycles || []).map(cycle => {
                    return {...cycle}
                })*/
                setInterviews(response.interviews || []);
                //setRatingsFields(response.ratingsFields || [])
                setTalentOffers(response.talentOffers || [])
                setIsLoadingInterviews(false)
            }, (error) => {
                setIsLoadingInterviews(false)
                //setIsError(true)
            })
        }
    }, [journeyId, isAdmin, userId]);

    useEffect(() => {
        const activeInterviews = (interviews||[]).filter(interview => !CLOSED_INTERVIEW_STATUSSES.includes(interview.status))

        let newInterviewProcesses = {}
        let processIds = []

        activeInterviews.forEach(function(interview) {
            let company = (interview.company||'').toLowerCase().trim()
            const title = (interview.title||'').toLowerCase().trim()

            if (company === 'constructor'){
                company = 'constructor.'
            }

            const processId = `C${company}T${title}`

            if(!processIds.includes(processId)){
                processIds.push(processId)
            }

            if(!newInterviewProcesses[processId]){
                newInterviewProcesses[processId] = {title, company, interviews:[]}
            }

            if(!newInterviewProcesses[processId].first || interview.interviewDate < newInterviewProcesses[processId].first){
                newInterviewProcesses[processId].first = interview.interviewDate
            }

            if(!newInterviewProcesses[processId].last || interview.interviewDate > newInterviewProcesses[processId].last){
                newInterviewProcesses[processId].last = interview.interviewDate
            }

            if(!newInterviewProcesses[processId].dateCreated || interview.dateCreated < newInterviewProcesses[processId].dateCreated){
                newInterviewProcesses[processId].dateCreated = interview.dateCreated < interview.interviewDate ? interview.dateCreated : interview.interviewDate
            }

            if(!newInterviewProcesses[processId].status){
                newInterviewProcesses[processId].status = interview.status
            }

            if(!newInterviewProcesses[processId].csComment){
                newInterviewProcesses[processId].csComment = interview.csComment
            }

            /*ratingsFields.forEach(function(ratingsField) {
                if(interview[ratingsField]){
                    if (!newInterviewProcesses[company].ratings){
                        newInterviewProcesses[company].ratings = {}
                    }
                    if (!newInterviewProcesses[company].ratings[ratingsField]){
                        newInterviewProcesses[company].ratings[ratingsField] = {sum:0, count:0}
                    }
        
                    newInterviewProcesses[company].ratings[ratingsField].sum += interview[ratingsField]
                    newInterviewProcesses[company].ratings[ratingsField].count++
                    //newInterviewProcesses[company].ratings[ratingsField].avg = newInterviewProcesses[company].ratings[ratingsField].sum / newInterviewProcesses[company].ratings[ratingsField].count
                    newInterviewProcesses[company][ratingsField] = newInterviewProcesses[company].ratings[ratingsField].sum / newInterviewProcesses[company].ratings[ratingsField].count
                }
            })*/

            newInterviewProcesses[processId].interviews.push(interview)
        })

        newInterviewProcesses = processIds.map(processId => {
            const processes = newInterviewProcesses[processId]
            return {
                ...processes, processId,
                talentOffer:talentOffers.find(talentOffer => processes.company === (talentOffer.company||'').toLowerCase().trim())
            }
        })

        newInterviewProcesses = newInterviewProcesses.sort((a, b) => {
            if (a.last >= today){
                if (b.last >= today){
                    return (a.last < b.last) ? -1 : 1
                } else {
                    return -1
                }
            }

            return 0;
        })

        setInterviewProcesses(newInterviewProcesses)
    }, [interviews, talentOffers, today]);

    const handleNewInterview = () => {
        setObjectToEdit({
            interviewDate:today,
            type:"HR Interview",
            status:"Interviewing",
            titleCategories: journeyData.titleCategories,
            titleGroup: journeyData.titleGroup,
            title: journeyData.title,
            seniorityLevel: journeyData.seniorityLevel||'',
        })
    }

    /*const handleNewInterviewInProccess = interview => {
        setObjectToEdit({
            company: interview.company,
            companyUrl: interview.companyUrl,
            title: interview.title,
            location: interview.location,
            status: interview.status,
            interviewerName: interview.interviewerName,
            interviewerEmail: interview.interviewerEmail,
            interviewerPhone: interview.interviewerPhone,
            //type:"HR Interview",
            seniorityLevel: interview.seniorityLevel,
            interviewDate:today,
        })
    }*/

    const handleEditStatus = (interview, offer) => {
        setObjectToEdit({...interview, fieldsType:'status', offer:offer})
    }

    const handleRecapInterview = interview => {
        setObjectToEdit({...interview, fieldsType:'recap'/*, offer:props.offer*/})
    }

    const handleEditInterview = (interview, fieldsType, offer) => {
        setObjectToEdit({...interview, fieldsType, offer})
    }

    const startEditInterviews = () => {
        setIsLoadingInterviews(true)
        props.preServerCall()
    }

    const finishEditInterviews = (response={}) => {
        if (response.interviews){
            setInterviews(response.interviews);
        }

        setTalentOffers(response.talentOffers || [])

        setIsLoadingInterviews(false)
        props.postServerCall()
    }

    const finishEditOffers = response => {
        if (response.talentOffers){
            setTalentOffers(response.talentOffers)
        }

        setIsLoadingInterviews(false)
        props.postServerCall()
    }

    const propsToChildren = {
        journeyData,
        isAdmin,
        userId,
        disabled,
        startEditInterviews,
        finishEditInterviews,
        setObjectToEdit,
        setOfferToEdit
    }

    return (
        <>
            {/*<InterviewProcessDialog {...propsToChildren} interviewProcess={selectedProcces} hnadleClose={()=>setSelectedProcces()}/>*/}
            {/*<InterviewToRecapDialog interviewToRecap={interviewToRecap} hnadleClose={setInterviewToRecap()}/>*/}

            <ContractOfferDialog 
                {...propsToChildren} 
                objectToEdit={offerToEdit} 
                setObjectToEdit={setOfferToEdit} 
                startEditData={startEditInterviews}
                finishEditData={finishEditOffers}
            />
            <InterviewsDialog {...propsToChildren} objectToEdit={objectToEdit} interviewsSort={-1}/>

            <Paper elevation={1}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 24px'}}>
                    <Typography><strong>Active Processes</strong></Typography>
                    <Button 
                        variant='contained' 
                        color='primary' 
                        disabled={disabled} 
                        size='large' 
                        style={{textTransform: 'capitalize', marginRight: 8}}
                        onClick={handleNewInterview}
                    >+  Add Interview</Button>
                </div>
                <Table /*className={classes.table}*/>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}/>
                            <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Date</TableCell>
                            <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Company</TableCell>
                            <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Title</TableCell>
                            <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Status</TableCell>
                            <TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Interviews</TableCell>
                            {/*<TableCell style={{color: '#6b7280', backgroundColor: '#f9fafb', borderTop: '1px solid #e0e0e0'}}>Actions</TableCell>*/}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {interviewProcesses.map((interviewProcess) => {
                        return (
                            <InterviewProcessRow 
                                key={interviewProcess.processId} 
                                interviewProcess={interviewProcess} 
                                handleRecapInterview={handleRecapInterview}
                                handleEditInterview={handleEditInterview}
                                handleEditStatus={handleEditStatus}
                                disabled={disabled}
                            />
                        )
                    })}
                    </TableBody>
                </Table>
            </Paper>

            {/*<Paper elevation={1} style={{padding: 16, marginTop: 8, marginBottom: 8, backgroundColor: '#edeafa'}}>
                <Typography variant='h3' style={{fontWeight: 500, fontSize: 18, lineHeight: '28px', marginBottom: 16}}>Tips for Success</Typography>
                <Grid container spacing={1}>
                    <Grid item sm={4} xs={12}>
                        <div elevation={1}  style={{backgroundColor: 'white', padding: 16, borderRadius: 8, height: '100%'}}>
                            <div>
                                <Lightbulb style={{height: 20, fill: '#6366f1', marginBottom: 8}}/>
                            </div>
                            <Typography variant='h4' style={{fontWeight: 500, marginBottom: 8, fontSize: 16}}>Interview Prep</Typography>
                            <Typography style={{fontSize: 14, color:'#4b5563'}}>All intervies handbook!</Typography>
                        </div>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <div elevation={1}  style={{backgroundColor: 'white', padding: 16, borderRadius: 8, height: '100%'}}>
                            <div>
                                <Lightbulb style={{height: 20, fill: '#8b5cf6', marginBottom: 8}}/>
                            </div>
                            <Typography variant='h4' style={{fontWeight: 500, marginBottom: 8, fontSize: 16}}>Interview Prep</Typography>
                            <Typography style={{fontSize: 14, color:'#4b5563'}}>All intervies handbook!</Typography>
                        </div>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <div elevation={1}  style={{backgroundColor: 'white', padding: 16, borderRadius: 8, height: '100%'}}>
                            <div>
                                <Lightbulb style={{height: 20, fill: '#06b6d4', marginBottom: 8}}/>
                            </div>
                            <Typography variant='h4' style={{fontWeight: 500, marginBottom: 8, fontSize: 16}}>Interview Prep</Typography>
                            <Typography style={{fontSize: 14, color:'#4b5563'}}>All intervies handbook!</Typography>
                        </div>
                    </Grid>
                </Grid>
                </Paper>*/}
        </>
    );
}